import React from 'react'

export const CustomToggle = React.forwardRef(({children, onClick}: any, ref: any) => (
  <button
    ref={ref}
    className='btn'
    onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
  >
    {children}
    <i className='fa-solid fa-ellipsis-vertical text-black'></i>
  </button>
))

export const CustomToggleForChat = React.forwardRef(({children, onClick}: any, ref: any) => (
  <i
    ref={ref}
    className='fa-solid fa-ellipsis-vertical text-black p-1'
    onClick={(e) => {
      e.preventDefault()
      onClick(e)
    }}
  ></i>
))
